<template>
  <div class="picmanger">
    <div class="header">
      <div style="display: flex; align-items: center">
        <img
          src="@/assets/house/breadicon.png"
          style="margin-right: 10px"
          alt
        />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>平台运维</el-breadcrumb-item>
          <el-breadcrumb-item>第三方接入</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div @click="refresh" class="refresh">
        <img
          :class="isRefresh ? 'imgmove' : ''"
          width="16px"
          height="16px"
          src="@/assets/house/refresh.png"
          alt
        />
        <p>刷新</p>
      </div>
    </div>

    <div class="main">
      <div class="head">
        <h4>第三方接入</h4>
        <p :style="{'color': isCustom ? customColor : isSimple ? '#E27B02' : '#194897'}" @click="addToken">+新增令牌</p>
      </div>

      <div class="tablebg" v-loading="isRefresh">
        <div style="width: 100%; margin: 0 auto">
          <thirdaccesstable
            :tableData="thirdAccessList"
            @closeClick="closeClick"
            @openClick="openClick"
            @seeClick="seeClick"
          ></thirdaccesstable>
        </div>

        <div class="pagination">
          <el-pagination @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page.sync="currentPage"
                         :page-size="pageSize"
                         layout="prev, pager, next"
                         :total="total">
          </el-pagination>
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="dialogVisibleAdd"
      width="26%"
      :before-close="handleCloseAdd"
    >
      <div slot="title" class="header-title" :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>{{dialogTitle}}</div>
      </div>
      <div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="关联用户" prop="user">
            <el-select
              clearable
              v-model="ruleForm.user"
              remote
              :remote-method="selectUser"
              filterable
              placeholder="请选择一个用户"
              style="width:100%;"
              :disabled="isChange"
            >
              <el-option
                v-for="item in userList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                style="width:100%;"
                v-html="'<span style=color:#303030;>'+item.label+'</span>'"
              ></el-option>
            </el-select>
            <p style="line-height:18px;margin-top:16px;">关联用户后，此令牌将可以拥有该用户所有的权限，请谨慎绑定。</p>
          </el-form-item>
          <el-form-item label="有效期" prop="date">
            <el-col v-if="!ruleForm.isAllTime" :span="15">
              <el-form-item>
                <el-date-picker
                  type="datetime"
                  placeholder="请选择授权截止日期"
                  v-model="ruleForm.date"
                  style="width: 100%"
                  value-format="timestamp"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </el-form-item> 
            </el-col>
            <el-col :span="7">
              <el-form-item>
                <el-checkbox style="margin-left:15px;" v-model="ruleForm.isAllTime">长期有效</el-checkbox>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="备注" prop="desc">
            <el-input type="textarea" placeholder="必填，不超过60个字" v-model="ruleForm.desc"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseAdd">关 闭</el-button>
        <el-button v-if="!isClick" :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}" type="primary" @click="beSure('ruleForm')">提 交</el-button>
        <el-button v-else :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}" type="primary" disabled>提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="dialogVisibleSee"
      width="26%"
      :before-close="handleCloseSee"
    >
      <div slot="title" class="header-title" :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>查看令牌</div>
      </div>
      <div>
        <el-input
          type="textarea"
          :rows="4"
          placeholder="暂无内容"
          v-model="token"
        >
        </el-input>
        <p style="margin-top: 10px">
          一旦第三方拥有此令牌后，即可通过接口调用本平台相关功能，请自行控制风险，以防令牌泄露产生风险。
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button  @click="handleCloseSee">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { thirdaccesstable } from "@/components/index";
import { mapActions } from "vuex";
import { listUser } from "@/api/user";
import {  listThirdPartyAccess,getThirdPartyAccess,addThirdPartyAccess,updateThirdPartyAccess} from '@/api/system'
import { getDate, formatConversion } from "@/plugins/getdate";
export default {
  components: {
    thirdaccesstable: thirdaccesstable,
  },
  data() {
    return {
      dialogVisibleSee: false,
      dialogVisibleAdd: false,
      isClick:false,
      token: "",
      total: 0,
      currentPage: 1,
      pageSize: 10,
      thirdAccessList: [],
      timeInt: "",
      isRefresh: false,

      isChange: false,
      dialogTitle:'新增令牌',
      userList: [],
      ruleForm: {
        user: "",
        date: new Date(),
        isAllTime: false,
        desc: "",
      },
      rules: {
        user: [
          { required: true, message: "请选择关联用户", trigger: "change" },
        ],
        date: [
          {
            type: "date",
            required: true,
            message: "请选择有效期",
            trigger: "change",
          },
        ],
        desc: [{ required: true, message: "请填写备注", trigger: "blur" }],
      },

      //限制
      pickerOptions: { 
         disabledDate(time) {
            return time.getTime() < Date.now() ;//如果没有后面的-8.64e7就是不可以选择今天的 
         }
  	  },
    };
  },
  methods: {
    //查看令牌
    handleCloseSee() {
      this.dialogVisibleSee = false;
    },
    seeClick(scope) {
      this.getThirdPartyAccessAsync({id:scope.row.id})
      this.dialogVisibleSee = true;
    },

    //新增令牌
    addToken() {
      this.dialogVisibleAdd = true;
      let data = { page: 0, pageSize: 20 };
      this.listUserAsync(data);
    },
    handleCloseAdd() {
      this.isChange = false
      this.ruleForm.isAllTime = false
      this.dialogTitle = '新增令牌'
      this.dialogVisibleAdd = false;
      this.$refs["ruleForm"].resetFields();
    },
    //检索用户
    selectUser(query) {
      let dataExa;
      if (query !== "") {
        dataExa = { page: 0, pageSize: 20, keyword: query };
        this.listUserAsync(dataExa);
      } else {
        dataExa = { page: 0, pageSize: 20 };
        this.listUserAsync(dataExa);
      }
    },
    beSure(formName) {
      
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isClick = true
          setTimeout(() => {
            this.isClick = false
          }, 2000);
          let val
          

          if(this.isChange){
            if(this.ruleForm.isAllTime){
              val = {
                id:this.ruleForm.id,
                desc:this.ruleForm.desc,
                expiryAt:0
              }
            }else{
              val = {
                id:this.ruleForm.id,
                desc:this.ruleForm.desc,
                expiryAt:this.ruleForm.date/1000
              }
            }
            this.updateThirdPartyAccessAsync(val)
          }else{
            if(this.ruleForm.isAllTime){
              val = {
                uid:this.ruleForm.user,
                desc:this.ruleForm.desc,
                expiryAt:0
              }
            }else{
              val = {
                uid:this.ruleForm.user,
                desc:this.ruleForm.desc,
                expiryAt:this.ruleForm.date/1000
              }
            }
            this.addThirdPartyAccessAsync(val)
          }

          
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    //停用
    closeClick(scope){
       this.$confirm('确定停用吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
        }).then(() => {
          let val = {
            id:scope.row.id,
            desc:scope.row.desc,
            expiryAt:-1
          }
          this.updateThirdPartyAccessAsync(val)
        })
    },
    //启动
    openClick(scope){
       this.$confirm('确定激活吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
        }).then(() => {
          this.isChange = true
          this.dialogTitle = '激活'
          this.userList = [
            {
              value: scope.row.createUserInfo.id,
              label: scope.row.createUserInfo.name,
            }
          ]
          if(scope.row.expiryAt == 0 || scope.row.expiryAt == -1){
            this.ruleForm = {
              user: scope.row.uid,
              date: scope.row.expiryAt * 1000 ,
              isAllTime: true,
              desc: scope.row.desc,
              id:scope.row.id
            }
          }else{
            this.ruleForm = {
              user: scope.row.uid,
              date: scope.row.expiryAt * 1000,
              isAllTime: false,
              desc: scope.row.desc,
              id:scope.row.id
            }
          }
          this.dialogVisibleAdd = true
        })
    },
    //分页事件
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange (val) {
      this.currentPage = val
      let data = { page: (this.currentPage - 1), pageSize: this.pageSize }
      // console.log(data)
      this.listThirdPartyAccessAsync(data)
    },

    //刷新表格
    refresh() {
      this.isRefresh = true;
      this.handleCurrentChange(this.currentPage);
      setTimeout(() => {
        this.isRefresh = false;
      }, 888);
    },

    
    //获取第三方接入详情
    async updateThirdPartyAccessAsync(val) {
      let { status, data, message, errors } = await updateThirdPartyAccess(val);
      if (status) {
        this.$message.success(message)
        this.handleCurrentChange(this.currentPage);
        this.handleCloseAdd()
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取第三方接入详情
    async getThirdPartyAccessAsync(val) {
      let { status, data, message, errors } = await getThirdPartyAccess(val);
      if (status) {
        this.token = data
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //创建第三方接入
    async addThirdPartyAccessAsync(val) {
      let { status, data, message, errors } = await addThirdPartyAccess(val);
      if (status) {
        this.$message.success(message)
        this.handleCurrentChange(this.currentPage);
        this.handleCloseAdd()
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取用户列表
    async listUserAsync(val) {
      let { status, data, message, pagination, errors } = await listUser(val);
      if (status) {
        this.userList = [];
        for (let i = 0; i < data.length; i++) {
          if (data[i].status == 1) {
            this.userList.push({
              value: data[i].id,
              label: data[i].name,
            });
          }
        }
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },
    //获取图片库列表
    async listThirdPartyAccessAsync(val) {
      this.isRefresh = true;
      let { status, data, message, pagination, errors } = await listThirdPartyAccess(val);
      if (status) {
        // console.log(data);
        for (let i = 0; i < data.length; i++) {
          data[i].bindName = data[i].bindingUserInfo.name
          data[i].createName = data[i].createUserInfo.name
          data[i].bindId = data[i].bindingUserInfo.id
          data[i].createMyAt = formatConversion(data[i].createAt.toString())
          data[i].endMyAt = formatConversion(data[i].expiryAt.toString())
          if(data[i].expiryAt == 0){
            data[i].endMyAt = '长期有效'
          }
          if(data[i].expiryAt == -1){
            data[i].endMyAt = '已过期'
          }
        }

        this.thirdAccessList = data
        this.total = pagination.total
        this.isRefresh = false;
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
        this.isRefresh = false;
      }
    },
  },
  created() {
    this.handleCurrentChange(this.currentPage);
    this.timeInt = setInterval(() => {
      this.handleCurrentChange(this.currentPage);
    }, 90000);
  },
  beforeDestroy() {
    // 组件销毁前调用
    clearTimeout(this.timeInt)
  },
  mounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./thirdaccess.scss";
@import "@/constants/elHeader.scss";
h4 {
  font-size: 18px;
}
</style>
